const home = {
  hero: {
    title: 'One Systeme Caisse',
    subtitle: 'Vende Fácil y Eficientemente',
    description: 'Una solución unificada para gestionar tu negocio. Convierte tu dispositivo en una caja registradora profesional y accede a todos tus datos donde quiera que estés.',
    cta: 'Solicitar una demo'
  },
  features: {
    title: 'Una solución completa para tu negocio',
    description: 'Descubre nuestras características innovadoras diseñadas para simplificar la gestión de tu negocio. Una interfaz intuitiva y herramientas potentes para optimizar tus ventas y productividad.',
    items: {
      touch: {
        title: '100% Táctil',
        description: 'Una interfaz completamente táctil para un uso intuitivo y rápido. Gestiona tus ventas y operaciones con un simple toque.'
      },
      tickets: {
        title: 'Tickets',
        description: 'Sistema de facturación fácil de usar para un seguimiento y gestión simplificada de pagos.'
      },
      responsive: {
        title: '100% Responsive',
        description: 'Una interfaz que se adapta perfectamente a todas las pantallas, desde el smartphone hasta la tablet, para una experiencia de usuario óptima en todos los dispositivos.'
      },
      barcode: {
        title: 'Código de barras',
        description: 'Escaneo rápido y preciso de códigos de barras para una gestión eficiente de inventario y ventas. Compatible con todos los tipos de códigos de barras estándar.'
      }
    }
  },
  quickStart: {
    title: 'Comienza a Usar PWA OS Caisse en Minutos',
    description: 'Una instalación rápida y un uso intuitivo te permiten comenzar inmediatamente. Configura tu caja, importa tus productos y comienza a vender en pocos clics.',
    items: {
      easy: 'Fácil de usar',
      secure: '100% Seguro',
      backup: 'Copia de seguridad automática'
    }
  },
  businessTypes: {
    title: 'Solución Ideal para Todo Tipo de Negocios',
    types: [
      'Restaurante',
      'Cafetería',
      'Comida rápida',
      'Pastelería',
      'Ropa lista',
      'Tienda de comestibles',
      'Cuidado y belleza',
      'Electrónica',
      'Muebles y decoración',
      'Joyería'
    ]
  },
  testimonials: {
    title: 'Testimonios de Comerciantes',
    rating: '4.4',
    reviews: '+3 000 reseñas en Google Play Store',
    items: [
      {
        title: 'Solución completa',
        text: 'El uso de PWA OS Caisse cumple perfectamente con las necesidades de mi negocio, permitiéndome lograr un éxito sostenible y un progreso notable.'
      },
      {
        title: 'Simplicidad y eficiencia',
        text: 'La interfaz fácil de usar y el funcionamiento fluido la convierten en una solución efectiva para gestionar mi negocio con total simplicidad.'
      },
      {
        title: 'Opción económica',
        text: 'La solución asequible me ofreció un valor excepcional al ayudarme a mejorar las operaciones de mi negocio sin arruinarme.'
      }
    ]
  }
};

export default home; 